import { useRef } from 'react'
import useCountUp from './hooks/useCountUp.js'

export default function Stat({ value, countTo, format = (n) => n, label, accent = false, className = '' }) {
  const ref = useRef(null)
  useCountUp(ref, countTo, format)
  const display = countTo != null ? format(countTo) : value
  return (
    <div className={`cn-stat ${className}`.trim()}>
      <span ref={ref} className={`cn-stat-value ${accent ? 'cn-stat-value--accent' : ''}`.trim()}>{display}</span>
      <span className="cn-stat-label">{label}</span>
    </div>
  )
}
